export default "/assets/7e0d0a5e91ed5be3.png"